export default __webpack_public_path__ + "media/images/dog-window-19ea803cf8e309f3952fe3e5d34ec573.png";